@switch (msg().type) {

  @case ('YOU_CHAT') {
    @let addr = msg().address;
    <article
      class="event-card event-card--chat"
      [class.event-card--dev]="dev.isDev(addr)"
      [class.ts-hidden]="mobile.isMobile && !showTimestamp()"
      [class.ts-floating]="mobile.isMobile && showTimestamp()"
      (click)="toggleTimestamp()"
    >
      <span class="timestamp">{{ msg().timestamp | date : 'HH:mm:ss' }}</span>
      <span class="faceoff">
        @if (addr) {
          <app-pixel-creature [addr]="addr"></app-pixel-creature>
        }
        @if (dev.isDev(addr)) { <span class="dev-badge">DEV</span> }
      </span>
      <div class="content">
        <div class="title">
          @if (addr) {
            <app-name-reveal
              class="pname"
              [address]="addr"
              [color]="addr | addressColor"
              [username]="msg().username ?? null"
              [twitterHandle]="msg().twitterHandle ?? null"
              [withProfilePreview]="true"></app-name-reveal>
            <span class="dim">:</span>
          }
          <span class="chat-body" [style.color]="addr ? (addr | addressColor) : null">{{ msg().body }}</span>
        </div>
      </div>
    </article>
  }

  @case ('OTHERS_CHAT') {
    @let addr = msg().address;
    <article
      class="event-card event-card--chat"
      [class.event-card--dev]="dev.isDev(addr)"
      [class.ts-hidden]="mobile.isMobile && !showTimestamp()"
      [class.ts-floating]="mobile.isMobile && showTimestamp()"
      (click)="toggleTimestamp()"
    >
      <span class="timestamp">{{ msg().timestamp | date : 'HH:mm:ss' }}</span>
      <span class="faceoff">
        @if (addr) {
          <app-pixel-creature [addr]="addr" [style.opacity]="server.isOnline(addr) ? '1' : '0.75'"></app-pixel-creature>
        }
        @if (dev.isDev(addr)) { <span class="dev-badge">DEV</span> }
      </span>
      <div class="content">
        <div class="title">
          @if (addr) {
            <app-name-reveal
              class="pname"
              [address]="addr"
              [color]="addr | addressColor"
              [username]="msg().username ?? null"
              [twitterHandle]="msg().twitterHandle ?? null"
              [withProfilePreview]="true"></app-name-reveal>
            <span class="dim">:</span>
          }
          <span class="chat-body" [style.color]="addr ? (addr | addressColor) : null">{{ msg().body }}</span>
        </div>
      </div>
    </article>
  }

  @case ('BATTLE_LOG') {
    @if (msg().battleLogEvent; as event) {
      @switch (event.type) {

        @case ('BATTLE_START') {
          <article
            class="event-card"
            [class.event-card--me]="involvesMe()"
            [class.ts-hidden]="mobile.isMobile && !showTimestamp()"
            [class.ts-floating]="mobile.isMobile && showTimestamp()"
            (click)="toggleTimestamp()"
          >
            <span class="timestamp">{{ event.timestamp | date : 'HH:mm:ss' }}</span>
            <span class="faceoff">
              <app-pixel-creature [addr]="event.p0"></app-pixel-creature>
              <span class="vs-lbl">VS</span>
              <app-pixel-creature [addr]="event.p1"></app-pixel-creature>
            </span>
            <div class="content">
              <div class="title">
                <app-name-reveal class="pname" [address]="event.p0" [color]="event.p0 | addressColor" [username]="event.p0Username" [twitterHandle]="event.p0TwitterHandle" [fallback]="displayFallback(event.p0)" [withProfilePreview]="true"></app-name-reveal>
                @if (event.dailyDay !== undefined) {
                  <span class="dim">challenges the daily boss!</span>
                } @else {
                  <span class="dim">vs</span>
                  <app-name-reveal class="pname" [address]="event.p1" [color]="event.p1 | addressColor" [username]="event.p1Username" [twitterHandle]="event.p1TwitterHandle" [fallback]="displayFallback(event.p1)" [withProfilePreview]="true"></app-name-reveal>
                }
              </div>
              @if (event.dailyDay === undefined) {
                <div class="sub">battle starts</div>
              }
            </div>
            @if (canSpectate()) {
              <button class="match-btn" (click)="$event.stopPropagation(); onSpectate(event.battleKey)">Spectate</button>
            }
          </article>
        }

        @case ('BATTLE_COMPLETE') {
          <article
            class="event-card"
            [class.event-card--me]="involvesMe()"
            [class.ts-hidden]="mobile.isMobile && !showTimestamp()"
            [class.ts-floating]="mobile.isMobile && showTimestamp()"
            (click)="toggleTimestamp()"
          >
            <span class="timestamp">{{ event.timestamp | date : 'HH:mm:ss' }}</span>
            <span class="faceoff">
                <app-pixel-creature [addr]="event.winner"></app-pixel-creature>
                <app-pixel-creature [addr]="event.loser"></app-pixel-creature>
            </span>
            <div class="content">
              <div class="title">
                @if (dailyOutcome(); as boss) {
                  <app-name-reveal class="pname" [address]="boss.address" [color]="boss.address | addressColor" [username]="boss.username" [twitterHandle]="boss.twitterHandle" [fallback]="shortHex(boss.address)" [withProfilePreview]="true"></app-name-reveal>
                  <span class="dim">{{ boss.won ? 'wins the daily boss battle!' : 'lost the daily boss battle!' }}</span>
                } @else {
                  <app-name-reveal class="pname" [address]="event.winner" [color]="event.winner | addressColor" [username]="event.winnerUsername" [twitterHandle]="event.winnerTwitterHandle" [fallback]="displayFallback(event.winner)" [withProfilePreview]="true"></app-name-reveal>
                  <span class="dim">defeats</span>
                  <app-name-reveal class="pname" [address]="event.loser" [color]="event.loser | addressColor" [username]="event.loserUsername" [twitterHandle]="event.loserTwitterHandle" [fallback]="displayFallback(event.loser)" [withProfilePreview]="true"></app-name-reveal>
                  <span class="dim">in {{ modeLabel(event.mode) }}</span>
                }
              </div>
            </div>
            <button class="match-btn" (click)="$event.stopPropagation(); onViewReplay(event.battleKey)">View Replay</button>
          </article>
        }

        @case ('GACHA_ROLL') {
          <article
            class="event-card"
            [class.ts-hidden]="mobile.isMobile && !showTimestamp()"
            [class.ts-floating]="mobile.isMobile && showTimestamp()"
            (click)="toggleTimestamp()"
          >
            <span class="timestamp">{{ event.timestamp | date : 'HH:mm:ss' }}</span>
            <span class="faceoff">
              <app-pixel-creature [addr]="event.player"></app-pixel-creature>
              @if (event.monIds.length === 1) {
                <app-mon-static-sprite class="mon-sprite" [monId]="event.monIds[0]" spriteType="mini" />
              }
            </span>
            <div class="content">
              <div class="title">
                <app-name-reveal class="pname" [address]="event.player" [color]="event.player | addressColor" [username]="event.playerUsername" [twitterHandle]="event.playerTwitterHandle" [fallback]="shortHex(event.player)" [withProfilePreview]="true"></app-name-reveal>
                <span class="dim">rolled</span>
                @if (event.monIds.length === 1) {
                  <span class="mon-name">{{ monName(event.monIds[0]) }}</span>
                } @else {
                  <span class="count">{{ event.monIds.length }}</span>
                  <span class="dim">mons</span>
                }
              </div>
              @if (event.monIds.length > 1) {
                <div class="sub sprite-strip">
                  @for (id of event.monIds; track id) {
                    <app-mon-static-sprite class="mon-sprite" [monId]="id" spriteType="mini" />
                  }
                </div>
              }
            </div>
          </article>
        }

        @case ('MON_LEVEL_UP') {
          <article
            class="event-card"
            [class.event-card--me]="involvesMe()"
            [class.ts-hidden]="mobile.isMobile && !showTimestamp()"
            [class.ts-floating]="mobile.isMobile && showTimestamp()"
            (click)="toggleTimestamp()"
          >
            <span class="timestamp">{{ event.timestamp | date : 'HH:mm:ss' }}</span>
            <span class="faceoff">
              <app-pixel-creature [addr]="event.player"></app-pixel-creature>
              <app-mon-static-sprite class="mon-sprite" [monId]="event.monId" spriteType="mini" />
            </span>
            <div class="content">
              <div class="title">
                <app-name-reveal class="pname" [address]="event.player" [color]="event.player | addressColor" [username]="event.playerUsername" [twitterHandle]="event.playerTwitterHandle" [fallback]="shortHex(event.player)" [withProfilePreview]="true"></app-name-reveal>
                <span class="dim possessive">'s</span>
                <span class="mon-name">{{ monName(event.monId) }}</span>
                <span class="dim">leveled up!</span>
              </div>
              <div class="sub">
                <span class="count">lv {{ event.oldLevel }}</span>
                <span class="dim">→</span>
                <span class="count">lv {{ event.newLevel }}</span>
              </div>
            </div>
          </article>
        }

        @case ('GACHA_FULL_ROLL') {
          <article
            class="event-card event-card--new"
            [class.ts-hidden]="mobile.isMobile && !showTimestamp()"
            [class.ts-floating]="mobile.isMobile && showTimestamp()"
            (click)="toggleTimestamp()"
          >
            <span class="timestamp">{{ event.timestamp | date : 'HH:mm:ss' }}</span>
            <span class="faceoff">
              <app-pixel-creature [addr]="event.player"></app-pixel-creature>
              <span class="sparkle">✦</span>
            </span>
            <div class="content">
              <div class="title">
                <app-name-reveal class="pname" [address]="event.player" [color]="event.player | addressColor" [username]="event.playerUsername" [twitterHandle]="event.playerTwitterHandle" [fallback]="shortHex(event.player)" [withProfilePreview]="true"></app-name-reveal>
                <span class="dim">enters the arena</span>
              </div>
              <div class="sub sprite-strip">
                @for (id of event.monIds; track id) {
                  <app-mon-static-sprite class="mon-sprite" [monId]="id" spriteType="mini" />
                }
                <span class="first-roll">nice mons</span>
              </div>
            </div>
          </article>
        }

      }
    }
  }

}
